import { httpError } from '#app/api/errors'

export type AuthMethod = {
    description: string
    href: string
    logo: string
    iframeCompatible: boolean
}

export type AuthMethodsResponse = {
    primary: AuthMethod[]
    optional: AuthMethod[]
}

export async function fetchAuthMethods(params: {
    lang?: string
    realm?: string
    method?: string
    originalUrl?: string
}): Promise<AuthMethodsResponse> {
    const qs = new URLSearchParams()
    if (params.lang) qs.set('lang', params.lang)
    if (params.realm) qs.set('realm', params.realm)
    if (params.method) qs.set('method', params.method)
    if (params.originalUrl) qs.set('originalUrl', params.originalUrl)
    const response = await fetch(`/auth/methods?${qs.toString()}`, {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin',
    })
    if (!response.ok) {
        throw await httpError(response, 'GET /auth/methods')
    }
    return (await response.json()) as AuthMethodsResponse
}
